module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQlJREFUeNqcVIENgjAQLJUBcANHYANhAtlARmADZQLdwBFkA2ACGQEngA3w3xzk86EQ+ORS+rTH//XKwcxHBPTA7ngTBuBDeBASQuDa4DnyHaEg1IQzqjvhXYV8BTgjRCWRyjNRhmo7rOkwz7yZDUx0IeSOD7FmjdDxyi17YN4S3E4s5iWTW0xi6LUGXWWAqmqrkne0phebBZtwFFZpc8MxS5JygYxPtGXYmd6f8M1IHCpyGYm0gDxqJkjF0UpTGrReCjsMWG98xZ45tAmVdqkwaKGJzIJ3NPELYzPexZGITfVd8U8EcbWnjNRoC0rxPN0Ku/Pv0OuK/J1ERyH2RJRvJGnV+I+fAAMA2O9LmdzGKgwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CalloutIcon_Multimedia.png
// module id = d0qn
// module chunks = 1